import {
  QueryClientProvider as BaseQueryClientProvider,
  type QueryClient,
} from '@tanstack/react-query';
import { queryClient as defaultQueryClient } from '../utils/query-client';

export function QueryClientProvider({
  children,
  queryClient,
}: {
  children: React.ReactNode;
  queryClient?: QueryClient;
}): React.ReactNode {
  return (
    <BaseQueryClientProvider client={queryClient ?? defaultQueryClient}>
      {children}
    </BaseQueryClientProvider>
  );
}
